import type { CategoryDefinition } from '@/types';

export const carDetailingCategories: readonly CategoryDefinition[] = [
  { id: 'car-detailing.exterior',   name: 'Exterior',   icon: 'car-front',  color: 'indigo', order: 1, description: 'Washing, decontamination and finishing' },
  { id: 'car-detailing.interior',   name: 'Interior',   icon: 'armchair',   color: 'violet', order: 2, description: 'Cabin cleaning and fabric care' },
  { id: 'car-detailing.protection', name: 'Protection', icon: 'shield',     color: 'blue',   order: 3, description: 'Waxes, sealants and coatings' },
  { id: 'car-detailing.premium',    name: 'Premium',    icon: 'gem',        color: 'amber',  order: 4, description: 'High-margin correction and coating work' },
];
